import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { ToastKind, ToastService } from '../../../core/portal/toast.service';
import { AppToastIconsModule } from './app-toast-icons.module';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule, AppToastIconsModule],
  template: `
    @if (toast.active(); as state) {
      <div
        class="app-toast"
        [class.app-toast--leaving]="toast.leaving()"
        [class.app-toast--success]="state.kind === 'success'"
        [class.app-toast--error]="state.kind === 'error'"
        [class.app-toast--info]="state.kind === 'info'"
        [class.app-toast--neutral]="state.kind === 'neutral'"
        [attr.role]="state.kind === 'error' ? 'alert' : 'status'"
        aria-live="polite"
      >
        @if (iconName(); as name) {
          <lucide-icon class="app-toast__icon" [name]="name" [size]="20" [strokeWidth]="2.25" />
        }
        <p class="app-toast__body">{{ state.message }}</p>
        <button type="button" class="app-toast__close" aria-label="Dismiss" (click)="toast.dismiss()">
          <lucide-icon name="x" [size]="18" [strokeWidth]="2.25" />
        </button>
      </div>
    }
  `,
  styleUrl: './app-toast.component.css',
})
export class AppToastComponent {
  readonly toast = inject(ToastService);

  readonly iconName = computed((): 'circle-check' | 'circle-alert' | 'info' | null => {
    const kind: ToastKind | undefined = this.toast.active()?.kind;
    switch (kind) {
      case 'success':
        return 'circle-check';
      case 'error':
        return 'circle-alert';
      case 'info':
        return 'info';
      default:
        return null;
    }
  });
}
